module.exports = __webpack_public_path__ + "img/chart2_image_anim.7f69ef34.gif";